import { Tool } from '../../data/tools';

export const metadata: Tool = {
  id: 'who-in-space',
  name: 'Who is in Space Right Now?',
  description: 'Track the count and names of astronauts currently orbiting Earth on the International Space Station and Tiangong.',
  category: 'Earth & Space',
  icon: 'Rocket',
  route: '/tools/who-in-space',
  metaTitle: 'Who is in Space Right Now? — Astronaut Live Tracker',
  metaDescription: 'Find out exactly how many people are in orbit right now, their names, which space station they are aboard (ISS or Tiangong), and links to their profiles.',
  keywords: [
    'who is in space right now',
    'astronauts in space list',
    'current space crew',
    'international space station crew',
    'tiangong station crew',
    'live astronaut tracker',
    'humans in space count'
  ],
  longDescription: 'The Who is in Space Right Now tool queries live orbital records to return the names of all astronauts, cosmonauts, and space tourists currently orbiting the Earth. It segregates space travelers by their active craft (the ISS or China\'s Tiangong Space Station) and connects to Wikipedia resource summaries.',
  howToUse: [
    'View the total number of people currently orbiting Earth displayed at the top.',
    'Switch between station capsules to see the respective crews.',
    'Click on any astronaut\'s name card to read more about their missions and biography on Wikipedia.'
  ],
  benefits: [
    'Fetches live astronaut counts directly from orbital registry APIs.',
    'Provides direct reference links for homework, space tracking, and research.',
    'Runs fully client-side without cookies or trackers.'
  ],
  faq: [
    {
      question: 'Which space stations are currently inhabited?',
      answer: 'Currently, there are two active, permanently inhabited space stations in low Earth orbit: the International Space Station (ISS) and China\'s Tiangong Space Station.'
    },
    {
      question: 'How often is the astronaut database updated?',
      answer: 'The underlying registry updates dynamically whenever new launches occur (e.g. SpaceX Crew Dragon, Soyuz, or Shenzhou missions) or when crews return to Earth.'
    },
    {
      question: 'Why are some astronauts not categorized by station?',
      answer: 'Occasionally, astronauts are in transit aboard spacecraft (e.g. during orbital transit inside Crew Dragon or Soyuz capsules prior to docking). They will show their craft name as the location.'
    }
  ]
};
